import React, { useContext } from "react";
import "./style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { MdDelete } from "react-icons/md";
import { FaMinus, FaPlus } from "react-icons/fa";
import { Button } from "@mui/material";
import { useState, useEffect } from "react";
import { FaCartShopping } from "react-icons/fa6";
import { Formatter } from "utils/formatter";
import { getDetailedCart } from "services/user/cartService";
import { CartContext } from "context/CartContext";
import { updateQuantity } from "services/user/cartService";
// import "react-toastify/dist/ReactToastify.css";
import { PacmanLoader } from "react-spinners";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";

import Notification from "component/user/notification/notification";

const CartItems = () => {
  const [cartItems, setCartItems] = useState([]); // Lưu dữ liệu giỏ hàng từ API
  const [quantityDistinctItems, setquantityDistinctItems] = useState([]);
  const [selectedItemsFromCart, setSelectedItemsFromCart] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(false);

  const [notification, setNotification] = useState(null);
  const { removeFromCart } = useContext(CartContext);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const fetchCartData = async () => {
      try {
        setIsLoading(true);
        const response = await getDetailedCart(token,currentPage);
        setCartItems(response.data.content);
        setquantityDistinctItems(response.data.page.totalElements);
        setTotalPages(response.data.page.totalPages)
      } catch (error) {
        console.error("Error fetching cart data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCartData();
  }, [currentPage]);

  const handleSelectItem = (itemId, addedQuantity) => {
    setSelectedItemsFromCart((prevSelected) => {
      if (prevSelected.some((item) => item.id === itemId)) {
        // Nếu sản phẩm đã được chọn, thì bỏ chọn
        return prevSelected.filter((item) => item.id !== itemId);
      } else {
        // Thêm sản phẩm vào danh sách đã chọn
        return [...prevSelected, { id: itemId, quantity: addedQuantity }];
      }
    });
  };

  const handleConfirmOrder = () => {
    if (selectedItemsFromCart.length > 0) {
      // console.log("id và quantity từ cartItem: ", selectedItemsFromCart);
      navigate("/confirm-order", {
        state: { items: selectedItemsFromCart, source: "CartItems" },
      });
    } else {
      console.error("No items selected");
    }
  };

  const handleRemoveItem = async (itemId) => {
    try {
      const response = await removeFromCart(itemId);
  
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Thành công!",
          text: "Xóa sản phẩm ra khỏi giỏ hàng thành công!",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
          customClass: {
            popup: "my-swal", // Liên kết với lớp CSS
          },
        });
        updateCartItems(itemId);
      }
    } catch (error) {
      console.error("Error removing item:", error);
    }
  };

  const handleDecreaseQuantity = async (id, quantity) => {
    const newQuantity = quantity - 1;
    if (newQuantity > 0) {
      await updateItemQuantity(
        id,
        newQuantity,
        "Cập nhật số lượng thành công!"
      );
      //sau khi cập nhật sl, cập nhật này để tính tạm tính
      setSelectedItemsFromCart((prevSelected) =>
        prevSelected.map((item) =>
          item.id === id ? { ...item, quantity: newQuantity } : item
        )
      );
    } else {
      await handleRemoveItem(id);
    }
  };

  const handleIncreaseQuantity = async (id, quantity) => {
    const newQuantity = quantity + 1;
    await updateItemQuantity(id, newQuantity, "Cập nhật số lượng thành công!");
    setSelectedItemsFromCart((prevSelected) =>
      prevSelected.map((item) =>
        item.id === id ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  // Cập nhật số lượng sản phẩm trong giỏ hàng
  const updateItemQuantity = async (id, quantity, successMessage) => {
    try {
      setIsLoading(true);
      const response = await updateQuantity(token, id, quantity);
      if (response.status === 200) {
        setCartItems((prevItems) =>
          prevItems.map((item) =>
            item.id === id ? { ...item, addedQuantity: quantity } : item
          )
        );
        setNotification(successMessage);
      }
    } catch (error) {
      console.error("Error updating quantity:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Cập nhật giỏ hàng và số lượng sau khi xóa sản phẩm
  const updateCartItems = async (itemId) => {
    setCartItems((prevCartItems) =>
      prevCartItems.filter((item) => item.id !== itemId)
    );
    // await fetchCartCount();
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allItems = cartItems
        .filter((item) => item.availableQuantity > 0)
        .map((item) => ({
          id: item.id,
          quantity: item.addedQuantity,
        }));
      setSelectedItemsFromCart(allItems);
    } else {
      setSelectedItemsFromCart([]);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Cuộn mượt
    });
  };
  const renderPagination = () => {
    const totalButtonsToShow = 5; // Số nút muốn hiển thị (bao gồm trang hiện tại)
    const pages = [];
    const startPage = Math.max(
      0,
      currentPage - Math.floor(totalButtonsToShow / 2)
    );
    const endPage = Math.min(
      totalPages - 1,
      startPage + totalButtonsToShow - 1
    );

    if (startPage > 0) {
      pages.push(0); // Trang đầu tiên
      if (startPage > 1) {
        pages.push("..."); // Dấu "..."
      }
    }

    // Hiển thị các trang xung quanh trang hiện tại
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    // Hiển thị nút "..." và trang cuối cùng
    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        pages.push("..."); // Dấu "..."
      }
      pages.push(totalPages - 1); // Trang cuối cùng
    }

    return pages;
  };


  const isAllSelected =
    cartItems.filter((item) => item.availableQuantity > 0).length > 0 &&
    selectedItemsFromCart.length ===
      cartItems.filter((item) => item.availableQuantity > 0).length;


    

  return (
    <div classname ="background-cartItems pb-4" style={{ backgroundColor: "#f1e9f3", paddingBottom: "40px",}}>
    <div className="container sumary mt-7 mb-4">
      {notification && (
        <Notification
          message={notification}
          onClose={() => setNotification(null)}
        />
      )}
      <div className="row">
        <div className="col-9 box box1 ms-4">
          <div className="icon-cart">
            {" "}
            <FaCartShopping />
            <span className="quantityDistinctItems ms-2">
              ({quantityDistinctItems} sản phẩm)
            </span>
          </div>
          <div className="header d-flex align-items-center">
            <div className="first_checkbox">
              <input
                type="checkbox"
                id="selectAll"
                checked={isAllSelected}
                onChange={handleSelectAll}
              />
            </div>
            <div className="text">Chọn tất cả sản phẩm</div>
            <div className="sl">Số lượng</div>
            <div className="total">Giá bán</div>
          </div>

          {/* Render các sản phẩm từ API */}
          {cartItems.map((item) => (
            <div className="product-container p-2 mb-2" key={item.id}>
              <div className="product-item d-flex align-items-center justify-content-between">
                <div className="choose-item me-3">
                  <input
                    type="checkbox"
                    id={`item-${item.id}`}
                    checked={selectedItemsFromCart.some(
                      (selected) => selected.id === item.id
                    )}
                    onChange={() =>
                      handleSelectItem(item.id, item.addedQuantity)
                    }
                    disabled={item.availableQuantity === 0} // Disable checkbox nếu hết hàng
                  />
                </div>
                <img
                  src={item.imageLink}
                  alt={item.title}
                  className="img-fluid img-bordered"
                  style={{ width: "70px", height: "auto" }}
                />
                <div className="product-title">
                <Link to={`/details/${item.id}`} className="react-link">
  <p className="bookname">{item.title}</p>
</Link>
                </div>
                <div className="quantity align-items-center">
                  {item.availableQuantity === 0 ? (
                    <span className="text-noti">Sách tạm hết hàng</span>
                  ) : (
                    <>
                <Button
  className="ms-3"
  onClick={() => handleDecreaseQuantity(item.id, item.addedQuantity)}
  data-testid="decrease-button"
  aria-label="Giảm số lượng" // Thêm aria-label để nút có tên
>
  <FaMinus />
</Button>


                      <input
                        type="text"
                        value={item.addedQuantity}
                        readOnly
                        style={{ width: "50px", textAlign: "center" }}
                        data-testid="quantity-input"
                      />
                      <Button
                        className="me-3"
                        onClick={() =>
                          handleIncreaseQuantity(item.id, item.addedQuantity)
                        }
                         data-testid="increase-button"
                      >
                        <FaPlus />
                      </Button>
                    </>
                  )}
                </div>
                <div className="price">
                  <span className="ms-3">
                    {Formatter(item.discountedPrice)}
                  </span>
                </div>
              </div>
              {/* Nút Xóa vẫn hoạt động bình thường */}
              <button
                className="remove"
                onClick={() => handleRemoveItem(item.id)}
              >
                <MdDelete />
              </button>
            </div>
          ))}
        </div>

        <div className="col-3 box box2 mt-5 ">
          <div>
            <div className="content-money">
              <div className="roww-gia">
                <span>Tạm tính</span>
                <span>
                  {Formatter(
                    selectedItemsFromCart.reduce((acc, selectedItem) => {
                      const cartItem = cartItems.find(
                        (item) => item.id === selectedItem.id
                      );
                      return (
                        acc +
                        (cartItem
                          ? cartItem.discountedPrice * selectedItem.quantity
                          : 0)
                      );
                    }, 0)
                  )}
                </span>
              </div>
              {/* <div className="roww-gia">
                  <span>Giảm giá</span>
                  <span>0</span>
                </div> */}
              {/* <div className="roww-gia">
                <span>Phí vận chuyển</span>
                <span>{Formatter(10000)}</span>
              </div> */}
              <div className="roww-gia">
                <span>Mã giảm giá</span>
                <span>0</span>
              </div>
              <hr />
              <div className="roww-gia">
                <span>Thành tiền</span>
                <span>
                  {Formatter(
                    selectedItemsFromCart.reduce((acc, selectedItem) => {
                      const cartItem = cartItems.find(
                        (item) => item.id === selectedItem.id
                      );
                      return (
                        acc +
                        (cartItem
                          ? cartItem.discountedPrice * selectedItem.quantity
                          : 0)
                      );
                    }, 0)
                  )}
                </span>
              </div>
              <button className="btn mua-hang" onClick={handleConfirmOrder}>
                Mua hàng
              </button>
            </div>
            <p className="note">Lưu ý: phí vận chuyển 10.000-30.000 tùy vào địa chỉ giao hàng!</p>

          </div>
        </div>

        


         {/* Phân trang */}
      <div className="paginationn">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 0}
          className="pagination-arrow"
        >
          «
        </button>
        {renderPagination().map((page, index) =>
          typeof page === "number" ? (
            <button
              key={index}
              onClick={() => handlePageChange(page)}
              className={currentPage === page ? "active" : ""}
            >
              {page + 1}
            </button>
          ) : (
            <span key={index} className="pagination-ellipsis">
              ...
            </span>
          )
        )}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages - 1}
          className="pagination-arrow"
        >
          »
        </button>
      </div>

        {isLoading && (
          <div className="modal">
            <div className="overlay_loading">
              <div className="modal-content_loading">
                <div className="d-flex">
                  <PacmanLoader color="#5e2e86" />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
    </div>
  );
};

export default CartItems;
